<template>
  <div class="order-submission">
    <div
      class="allAddress"
      :style="
        store_self_mention && isstore && is_mention ? '' : 'padding-top: 0.2rem'
      "
    >
      <div class="nav acea-row">
        <!-- 修改部位 -->
        <!-- <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="store_self_mention && isstore && is_mention"
        ></div> -->
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on2'"
          @click="addressType(1)"
          v-if="store_self_mention && isstore && is_mention"
        ></div>
      </div>
      <div
        :class="
          addressInfo.real_name
            ? 'address acea-row row-between-wrapper'
            : 'addressadd acea-row row-between-wrapper'
        "
        v-if="shipping_type === 0"
      >
        <!-- 有收货地址 -->
        <div
          class="addressCon"
          v-if="addressInfo.real_name"
          @click="addressTap"
        >
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.is_default"
              >[默认]</span
            >
            {{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <!-- 无收货地址，弹框新增 -->
        <!-- <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div> -->
        <!-- 无收货地址，本页新增 -->
        <div class="addressCon" v-else>
          <div class="list">
            <div class="item acea-row row-between-wrapper">
              <div class="name">姓名<i class="red">*</i></div>
              <input
                type="text"
                placeholder="请输入姓名"
                v-model="userAddress.real_name"
                required
              />
            </div>
            <div class="item acea-row row-between-wrapper">
              <div class="name">联系电话<i class="red">*</i></div>
              <input
                type="number"
                pattern="[0-9]*"
                placeholder="请输入联系电话"
                v-model="userAddress.phone"
                required
              />
            </div>
            <div class="item acea-row row-between-wrapper">
              <div class="name">所在地区<i class="red">*</i></div>
              <div
                class="
                  picker
                  acea-row
                  row-between-wrapper
                  select-value
                  form-control
                "
              >
                <div class="address">
                  <div slot="right" @click.stop="show2 = true">
                    {{ model2 || "请选择收货地址" }}
                  </div>
                  <CitySelect
                    ref="cityselect"
                    v-model="show2"
                    :callback="result2"
                    :items="district"
                    :ready="ready"
                    provance=""
                    city=""
                    area=""
                  ></CitySelect>
                </div>
                <!-- <div class="iconfont icon-dizhi font-color-red"></div> -->
              </div>
            </div>
            <div class="item acea-row row-between-wrapper">
              <div class="name">详细地址<i class="red">*</i></div>
              <input
                type="text"
                placeholder="请填写具体地址"
                v-model="userAddress.detail"
                required
              />
            </div>
            <div class="item acea-row row-between-wrapper">
              <div class="name">学校<i class="red">*</i></div>
              <input
                type="text"
                placeholder="请填写所在学校"
                v-model="userAddress.school_name"
              />
            </div>
          </div>
        </div>
        <div
          v-if="addressInfo.real_name"
          @click="addressTap"
          class="iconfont icon-jiantou"
        ></div>
      </div>
      <div class="address acea-row row-between-wrapper" v-else>
        <div class="addressCon">
          <div class="name" v-if="storeItem">
            {{ storeItem.name }}
            <span class="phone" v-text="storeItem.phone"></span>
          </div>
          <!-- <div
            v-text="storeItem.address + ',' + storeItem.detailed_address"
            v-if="storeItem && storeItem.address"
          ></div> -->
        </div>
        <!-- 自提右边箭头 -->
        <!-- <div class="iconfont icon-jiantou"></div> -->
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <div
        class="item acea-row row-between-wrapper"
        @click="couponTap"
        v-if="deduction === false && usableCoupon.id"
      >
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <!-- <div class="item acea-row row-between-wrapper" v-if="deduction === false">
        <div>积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  当前积分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <div
        class="item acea-row row-between-wrapper"
        v-if="
          orderGroupInfo.priceGroup.vipPrice > 0 &&
          pinkId == 0 &&
          orderGroupInfo.bargain_id == 0 &&
          orderGroupInfo.combination_id == 0 &&
          orderGroupInfo.seckill_id == 0
        "
      >
        优惠
        <div class="discount">-￥{{ orderGroupInfo.priceGroup.vipPrice }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="shipping_type === 0 && addressInfo.real_name"
      >
        <div>快递费用</div>
        <div class="discount">
          {{
            orderPrice.pay_postage > 0
              ? "￥" + orderPrice.pay_postage
              : "免运费"
          }}
        </div>
        <p class="express-tips">
          (备注：新疆地区发邮政国内小包，具体时效以实际派送为准。)
        </p>
      </div>
      <div v-else-if="shipping_type === 1">
        <div class="item acea-row row-between-wrapper">
          <div>联系人<i class="red">*</i></div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系姓名"
              v-model="contacts"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>联系电话<i class="red">*</i></div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系电话"
              v-model="contactsTel"
            />
          </div>
        </div>
      </div>
      <div class="item">
        <div>备注信息</div>
        <textarea
          placeholder="请添加备注（150字以内）"
          v-model="mark"
        ></textarea>
      </div>
    </div>
    <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="!isWeixin"
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            v-if="iszfbshow"
            class="payItem acea-row row-middle"
            :class="active === 'alipay' ? 'on' : ''"
            @click="payItem('alipay')"
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-zhifubao"
                :class="active === 'alipay' ? 'bounceIn' : ''"
              ></div>
              支付宝支付
            </div>
            <div class="tip">支付宝快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
            v-if="yuePayStatus === 1"
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              余额支付
            </div>
            <div class="tip">可用余额：{{ userInfo.now_money || 0 }}</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="
              offlinePayStatus === 1 &&
              deduction === false &&
              shipping_type === 0
            "
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              线下支付
            </div>
            <div class="tip">线下方便支付</div>
          </div>
        </div>
      </div>
    </div>
    <div class="moneyList">
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.total_price !== undefined"
      >
        <div>商品总价：</div>
        <div class="money">￥{{ orderPrice.total_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.pay_postage > 0"
      >
        <div>运费：</div>
        <div class="money">+￥{{ orderPrice.pay_postage }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.coupon_price > 0"
      >
        <div>优惠券抵扣：</div>
        <div class="money">-￥{{ orderPrice.coupon_price }}</div>
      </div>
      <!--     <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deduction_price > 0"
      >
        <div>积分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deduction_price }}</div>
      </div> -->
    </div>

    <div style="height: 1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计:
        <span class="font-color-red">￥{{ orderPrice.pay_price }}</span>
      </div>
      <div class="settlement" @click="createOrder">立即结算</div>
    </div>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      :cartid="cartid"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      @redirectEdit="addressEdit"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>

<script>
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getCity } from "@api/public";
import OrderGoods from "@components/OrderGoodsSubmit";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { storeInfo } from "@api/store";
import { getUser, postAddress } from "@api/user";
import { isWeixin, pay } from "@libs/wechat";
import { isPc } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
const NAME = "OrderSubmission",
  _isWeixin = isWeixin(),
  _isPc = isPc();
console.log(_isPc);
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow,
    CitySelect,
  },
  props: {},
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function () {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    },
  },
  data: function () {
    return {
      // isAdd:false,
      iszfbshow: true,
      show2: false,
      model2: "",
      district: [],
      userAddress: {
        real_name: "",
        phone: "",
        detail: "",
        school_name: "",
        is_default: 1,
      },
      address: {},
      addressInfoId: "",
      ready: false,
      cartid: "",
      offlinePayStatus: 2,
      yuePayStatus: 2,
      from: _isWeixin ? "weixin" : _isPc ? "weixinpc" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      // active: _isWeixin ? "weixin" : "yue",
      active: "weixin",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {},
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中",
      },
      mark: "",
      system_store: {},
      storeid:
        this.$cookies.get("storeid") !== undefined
          ? this.$cookies.get("storeid")
          : 0, //门店ID
      shipping_type: 0, // =0是快递  =1是自提
      isstore: false, //后台是否能查到门店，false是不能
      contacts: "",
      contactsTel: "",
      store_self_mention: 0, //是否门店自提，=1 开启自提 =0关闭自提
      is_mention: 0, //商品属性设置 =0关闭自提  =1开启自提
      userInfo: {},
      storeList: {},
    };
  },
  watch: {
    // useIntegral() {
    //   this.computedPrice();
    // },
    $route(n, from) {
      if (from.name == "AddAddress") {
        if (!this.addressLoaded) {
          this.addressLoaded = true;
          this.$refs.mychild.getAddressList();
        }
      }
      if (n.name === NAME) {
        this.getUserInfo();
        this.getCartInfo();
      }
    },
    shipping_type() {
      this.computedPrice();
    },
  },
  mounted: function () {
    if (this.$cookies.get("iszfbshow") == 1) {
      this.iszfbshow = false;
    }
    console.log(this.from);
    let that = this;

    that.getCityList();
    that.getUserInfo();
    that.getCartInfo();
    // that.getList();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
    if (that.$route.params.id !== undefined)
      that.cartid = that.$route.params.id;
  },
  methods: {
    //获取门店信息
    getInfo: function () {
      let that = this;
      storeInfo(that.storeid)
        .then((res) => {
          that.storeList = res.data;
          console.log(that.storeItem);
          that.shipping_type = 1;
          that.isstore = true;
        })
        .catch((err) => {
          that.isstore = false;
        });
    },
    // // 获取门店列表数据
    // getList: function() {
    //   let data = {
    //     latitude: cookie.get(LATITUDE) || "", //纬度
    //     longitude: cookie.get(LONGITUDE) || "", //经度
    //     page: 1,
    //     limit: 10
    //   };
    //   storeListApi(data)
    //     .then(res => {
    //       this.storeList = res.data.list[0];
    //     })
    //     .catch(err => {
    //       this.$dialog.error(err.msg);
    //     });
    // },
    // // 跳转到门店列表
    // showStoreList() {
    //   this.$store.commit("GET_TO", "orders");
    //   this.$router.push("/shop/storeList/orders");
    // },
    getUserInfo() {
      getUser()
        .then((res) => {
          this.userInfo = res.data;
        })
        .catch(() => {});
    },
    addressType: function (index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
    },
    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1,
        payType: this.active,
      })
        .then((res) => {
          const data = res.data;
          if (data.status === "EXTEND_ORDER") {
            this.$router.replace({
              path: "/order/detail/" + data.result.orderId,
            });
          } else {
            this.orderPrice = data.result;
          }
        })
        .catch((res) => {
          this.$dialog.error(res.msg);
        });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then((res) => {
          if (res.data.From_addressInfo) {
            this.userAddress = res.data.From_addressInfo;
            if (
              this.userAddress.province &&
              this.userAddress.city &&
              this.userAddress.district
            ) {
              this.address.city = this.userAddress.city;
              this.address.district = this.userAddress.district;
              this.address.province = this.userAddress.province;
              this.userAddress.is_default = 1;
              this.model2 =
                this.userAddress.province +
                " " +
                this.userAddress.city +
                " " +
                this.userAddress.district;
            }
          }
          this.offlinePayStatus = res.data.offline_pay_status;
          this.yuePayStatus = res.data.yue_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.is_mention = res.data.is_mention;
          this.store_self_mention = res.data.store_self_mention;
          this.computedPrice();
          if (this.storeid && this.store_self_mention && this.is_mention) {
            this.getInfo();
          }
        })
        .catch((err) => {
          this.$dialog.error(err.msg || "加载订单数据失败");
          this.$dialog.loading.close();
          this.$router.go(-1);
        });
    },
    addressTap: function () {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = true;
    },
    //编辑地址
    addressEdit() {
      this.addressLoaded = false;
      this.showAddress = true;
    },
    couponTap: function () {
      this.showCoupon = true;
    },
    changeCoupon: function (coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function (index) {
      this.active = index;
      this.computedPrice();
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },
    //新增地址 选择所在地区
    getCityList: function () {
      let that = this;
      getCity()
        .then((res) => {
          that.district = res.data;
          that.ready = true;
        })
        .catch((err) => {
          that.$dialog.error(err.msg);
        });
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      this.address.district = ret.itemName3;
    },
    createOrder() {
      let shipping_type = this.shipping_type;
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      // if (!this.addressInfo.id && !this.shipping_type)
      //   return this.$dialog.toast({ mes: "请选择收货地址" });
      if (this.shipping_type) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      } else {
        if (!this.addressInfo.real_name) {
          if (!this.userAddress.real_name)
            return this.$dialog.toast({ mes: "请填写收货人姓名" });
          if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.userAddress.phone)) {
            return this.$dialog.toast({ mes: "请填写正确的手机号" });
          }
          if (!this.model2)
            return this.$dialog.toast({ mes: "请选择所在地区" });
          if (!this.userAddress.detail)
            return this.$dialog.toast({ mes: "请填写详细地址" });
          if (!this.userAddress.school_name)
            return this.$dialog.toast({ mes: "请填写所在学校" });
        }
      }
      this.$dialog.loading.open("生成订单中");
      // 新增地址
      console.log(this.userAddress.is_default);
      let that = this,
        data = {
          real_name: this.userAddress.real_name,
          phone: this.userAddress.phone,
          address: this.address,
          detail: this.userAddress.detail,
          school_name: this.userAddress.school_name,
          is_default: this.userAddress.is_default,
        };
        console.log(data);
      if (!that.addressInfo.id && that.shipping_type === 0) {
        postAddress(data)
          .then(function (res) {
            console.log("新增地址成功");
            that.addressInfoId = res.data.id;
            console.log("1111111---" + that.addressInfoId);
            that.submit();
          })
          .catch((err) => {
            that.$dialog.error(err.msg);
          });
      } else {
        that.submit();
      }
    },
    submit() {
      let that = this;
      let shipping_type = that.shipping_type;
      let Source = that.$cookies.get("urlSource"),
        clickid = that.$cookies.get("clickid"),
        adid = that.$cookies.get("adid"),
        monitor_url = that.$cookies.get("monitor_url");
      //	that.$cookies.remove("urlSource");
      that.$cookies.remove("clickid");
      that.$cookies.remove("adid");
      that.$cookies.remove("monitor_url");
      //  hezi 二维码支付跳转
      let ishezi = cookie.get("hezi_tel");
      if (ishezi) {
        that.from = "gama";
      }
      console.log(that.from, "that.from");
      // 提交订单
      createOrder(that.orderGroupInfo.orderKey, {
        real_name: that.contacts,
        phone: that.contactsTel,
        addressId: that.addressInfo.id
          ? that.addressInfo.id
          : that.addressInfoId,
        useIntegral: that.useIntegral ? 1 : 0,
        couponId: that.usableCoupon.id || 0,
        payType: that.active,
        pinkId: that.pinkId,
        seckill_id: that.orderGroupInfo.seckill_id,
        combinationId: that.orderGroupInfo.combination_id,
        bargainId: that.orderGroupInfo.bargain_id,
        from: that.from,
        mark: that.mark || "",
        shipping_type: parseInt(shipping_type) + 1,
        store_id: that.storeItem ? that.storeItem.id : 0,
        source: Source || 0,
        clickid,
        adid,
        monitor_url,
      })
        .then((res) => {
          that.$dialog.loading.close();
          const data = res.data;
          let url = "/order/status/" + data.result.orderId;
          let heziurl = "/order/heziQrcode/" + data.result.orderId;

          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              that.$dialog.toast({ mes: res.msg });
              that.$router.replace({
                path: url + "/0?msg=" + res.msg,
              });
              break;
            case "SUCCESS":
              that.$dialog.success(res.msg);
              if (that.$cookies.isKey("iszfbshow")) {
                var spread = that.$cookies.get("urlSpread");
                that.$router.push("/user/recruit_index?spread=" + spread);
                that.$cookies.remove("iszfbshow");
              } else {
                that.$router.replace({
                  path: url + "/1",
                });
              }
              break;
            case "WECHAT_H5_PAY":
              if (that.$cookies.isKey("iszfbshow")) {
                var spread = that.$cookies.get("urlSpread");
                that.$router.push("/user/recruit_index?spread=" + spread);
                that.$cookies.remove("iszfbshow");
              } else {
                that.$router.replace({
                  path: url + "/2",
                });
              }

              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                if (that.$cookies.isKey("iszfbshow")) {
                  var spread = that.$cookies.get("urlSpread");
                  that.$router.push("/user/recruit_index?spread=" + spread);
                  that.$cookies.remove("iszfbshow");
                } else {
                  that.$router.replace({
                    path: url + "/4",
                  });
                }
              });
              break;
            case "ALIPAY_H5_PAY":
              that.$router.push("/order/detail/" + data.result.orderId);
              setTimeout(function () {
                console.log(data.result.jsConfig);
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                  // 是微信端
                  that.$router.push({
                    path: "/New",
                    query: {
                      orderId: data.result.orderId,
                    },
                  });
                } else {
                  location.replace(data.result.jsConfig);
                }
              }, 300);
              break;
            case "GAMA_PAY":
              that.$dialog.success(res.msg);
              that.$router.replace(
                heziurl + "?code_url=" + data.result.code_url
              );
              break;
          }
        })
        .catch((err) => {
          that.$dialog.error(err.msg || "创建订单失败");
          that.$dialog.loading.close();
          that.$router.go(-1);
        });
    },
  },
};
</script>
<style scoped>
.addressadd {
  width: 7.1rem;
  height: auto;
  margin: 0 auto;
}
/*添加地址*/
.list {
  background-color: #fff;
}
.list .item {
  padding: 0 0.3rem;
  min-height: 0.9rem;
  border-top: 0.01rem solid #eee;
  font-size: 0.3rem;
}
.list .item .name {
  width: 1.5rem;
  color: #333;
}
.list .item input {
  width: 5rem;
  font-size: 0.3rem;
}
.list .item input::placeholder {
  color: #999;
}
.list .item .picker {
  width: 5rem;
  color: #999;
}
.list .item .address {
  width: 4.57rem;
  height: auto !important;
  padding: 0;
  color: #999;
}
.list .item .picker .iconfont {
  font-size: 0.43rem;
}
.default {
  padding: 0 0.3rem;
  height: 0.9rem;
  background-color: #fff;
  margin-top: 0.23rem;
}
.default .def {
  margin-left: 0.6rem;
}
.keepBnt {
  width: 6.9rem;
  height: 0.86rem;
  border-radius: 0.5rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0.5rem auto 0.3rem auto;
  font-size: 0.32rem;
  color: #fff;
}
.wechatAddress {
  width: 6.9rem;
  height: 0.86rem;
  border-radius: 0.5rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0 auto;
  font-size: 0.32rem;
  color: #fe960f;
  border: 1px solid #fe960f;
}
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #e93323 0%,
    #f5f5f5 100%
  );
  background-image: -moz-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  padding-top: 1rem;
}
.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .allAddress .nav .item {
  width: 3.55rem;
}
.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}
.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  /* content: "快递配送"; 修改部位 */
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}
.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}
.order-submission .allAddress .nav .item.on2 {
  position: relative;
}
.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}
.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  /* content: "快递配送"; 修改部位 */
  content: "到店自提";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}
.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}
.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
.express-tips {
  color: #999;
  font-size: 0.24rem;
}
.order-submission .wrapper .item .list .payItem .name .iconfont {
  margin-left: 0.6rem;
}
.order-submission .wrapper .item .list .payItem .name .icon-zhifubao {
  background-color: #027aff;
}
@media screen and (min-width: 960px) {
  .addressadd {
    width: 3.55rem;
  }
  /*添加地址*/
  .list .item {
    padding: 0 0.15rem;
    min-height: 0.45rem;
    font-size: 0.15rem;
  }
  .list .item .name {
    width: 0.75rem;
  }
  .list .item input {
    width: 2.5rem;
    font-size: 0.15rem;
  }
  .list .item .picker {
    width: 2.5rem;
  }
  .list .item .address {
    width: 2.28rem;
  }
  .list .item .picker .iconfont {
    font-size: 0.21rem;
  }
  .default {
    padding: 0 0.15rem;
    height: 0.45rem;
    margin-top: 0.11rem;
  }
  .default .def {
    margin-left: 0.3rem;
  }
  .keepBnt {
    width: 3.45rem;
    height: 0.43rem;
    line-height: 0.43rem;
    margin: 0.25rem auto 0.15rem auto;
    font-size: 0.16rem;
  }
  .wechatAddress {
    width: 3.45rem;
    height: 0.43rem;
    line-height: 0.43rem;
    font-size: 0.16rem;
  }
  .order-submission .wrapper .shipping select {
    padding-right: 0.07rem;
  }
  .order-submission .wrapper .shipping .iconfont {
    font-size: 0.15rem;
  }
  .order-submission .allAddress {
    padding-top: 0.5rem;
  }
  .order-submission .allAddress .nav {
    width: 3.55rem;
  }
  .order-submission .allAddress .nav .item {
    width: 1.77rem;
  }
  .order-submission .allAddress .nav .item.on {
    width: 1.25rem;
  }
  .order-submission .allAddress .nav .item.on:before {
    font-size: 0.14rem;
    width: 1.77rem;
    line-height: 0.4rem;
  }
  .order-submission .allAddress .nav .item.on2:before {
    font-size: 0.14rem;
    width: 2.3rem;
    border-radius: 0.2rem 0.03rem 0 0;
    line-height: 0.3rem;
  }
  .order-submission .allAddress .address {
    width: 3.55rem;
    height: 0.75rem;
  }
  .order-submission .allAddress .line {
    width: 3.55rem;
  }
  .express-tips {
    font-size: 0.12rem;
  }
  .order-submission .wrapper .item .list .payItem .name .iconfont {
    margin-left: 0.3rem;
  }
}
</style>
